import { nextTick, watch } from 'vue';
import pkg from 'app/package.json';

export const formatMetaTitle = (name) => {
  if (name) {
    return `${name} | ${pkg.productName}`;
  }
  return pkg.productName;
};

export const useMetaTitle = (model) => {
  watch(model, () => {
    nextTick(() => {
      document.title = formatMetaTitle(model.value);
    });
  });
};
